import { SUPPORTED_CHAINS } from '@frontend/common';
import { defaultPublicRpc } from '@frontend/utils/env.client';
import { createConfig } from '@wagmi/core';
import { http } from 'viem';

const chains = SUPPORTED_CHAINS;

const transports = Object.fromEntries(
  chains.map((chain) => [
    chain.id,
    http(defaultPublicRpc(chain.id), { batch: true }),
  ]),
) as Record<number, ReturnType<typeof http>>;

export const config = createConfig({
  chains,
  transports,
  batch: {
    multicall: true,
  },
});
